export const about = [
  <>
    Ahhoz, hogy fenn tudd tartani a szervezeted <b>biológiai egyensúlyát</b>,
    fontos, hogy helyre állítsd <b>lelked harmóniáját</b> is, mert ez segíti a
    test sejtjeinek <b>öngyógyító folyamatait</b> a meridián rendszeren
    keresztül.
  </>,

  <>
    A metamorf technika a <b>gerinc reflexpontjait</b> kezeli. A tudatallattiból
    oldja fel a blokkokat három idősíkban: előző életben, méhen belüli
    időszakban és a jelen életünkben.
  </>,

  <>
    Nem kell ismerni a konkrét problémát, hiszen lehet, hogy nem is ismert.{" "}
    <b>Nem keressük az okokat</b>, nem akarunk rájönni a miértekre.
  </>,

  <>
    "<b>Elméletben</b> tudom a megoldást, de valahogy <b>mégsem sikerül</b>{" "}
    kijönni a gödörből..."
  </>,
];
export const during = [
  <>
    A bowen kezeléssel <b>kombinálva</b> növeli a testi és lelki diszfunkciók
    korrigálását
  </>,
  <>Masszázs ágyon, ruházatban, de csupasz lábbal</>,
  <>
    4-5 perces vezetett meditáció után kezdődik a kezelés a lábakon, kezeken és
    a fejen, ami alatt nem beszélgetünk, majd a kezelés végén, szintén vezetve
    “hozlak ki” a jelenbe
  </>,
];
export const usefulFor = [
  [
    <>Szorongás, félemek, lelki megakadások</>,
    <>Álmatlanság</>,
    <>Kilátástalanság érzése</>,
  ],
  [
    <>Depresszió</>,
    <>
      Pszichoszomatikus tüneteknél: gyomorfekély, izzadás, vérnyomás emelkedés,
      hajhullás, migrén, idegbecsípődés, vállfájdalom
    </>,
  ],
];

export const technique = (
  <>
    Csökkennek a félelmek, haragos gondolatok, nyomasztó érzések.{" "}
    <b>Nyitottabbá</b>, életerősebbé válunk,{" "}
    <b>nő az önbizalmunk, jókedvűbbek, optimistábbak</b> leszünk, ezáltal{" "}
    <b>javul az életminőségünk.</b>
  </>
);
